<script>
// import { useCartStore } from '@/stores'
//const cartStore = useCartStore()
import { getCarList, Add_good, del_good } from '../../apis/carList'

export default {
  data() {
    return {
      carList: [],
    }
  },
  created() {
    this.lang = localStorage.getItem("language") == "zh" ? "zh" : "en";
  },
  mounted() { this.getCarListData() },
  computed:{
    totalprice(){
      let count = 0
      this.carList.forEach(item => {
        count+=item.price
      });
      return count
    }
  },
  methods: {
    // 获取购物车数据
    async getCarListData() {
      // console.log(123)
      const res = await getCarList(3);
      this.carList = this.car_list_data(res.data)
    },
    // 购物车数据处理
    car_list_data(data) {
      return Object.entries(data).flatMap(([key, values]) => {
        return values
      })

    },
    // 自定义事件
    triggerCustomEvent(){
      this.$emit('customEvent', this.getCarListData());
    }
  }
}


</script>

<template>
  <div class="cart">
    <!-- <a class="curr" href="javascript:;"> -->
    <a class="curr" href="javascript:;">
      <!-- 红点 -->
      <!-- <i class="iconfont icon-gouwuche mr-7"></i><em>xx</em> -->
      <i class="iconfont icon-gouwuche mr-7"></i>
      <em>{{ carList.length }}</em>
      <i class="icontext">{{ $t("购物车") }}</i>
    </a>
    <div class="layer">
      <div class="list">
        <!-- v-for="i in cartStore.cartList" :key="i" 遍历购物车 -->
        <div class="item" v-for="i in carList" :key="i.partsName">
          <RouterLink to="">
            <!-- :src="typeof i.picture === 'string' ? i.picture : i.picture[0]" -->
            <img alt="" :src="i.picture.includes('https')? i.picture:i.companyLogo" style="object-fit: fill;" />
            <div class="center">
              <p class="name ellipsis-2 ">
                {{ lang == "zh" ? i.partsName: i.partsEname}}
              </p>
              <p class="attr ellipsis">{{ i.supplierName }}</p>
            </div>
            <div class="right">
              <p class="price">&yen;{{ i.price }}</p>
              <p class="count">x {{ i.quantity }}</p>
            </div>
          </RouterLink>
          <!-- 仓库方法 -->
          <i class="iconfont icon-close-new" @click="cartStore.deleteCart(i.skuId)"></i>
        </div>
      </div>
      <div class="foot">
        <div class="total">
          <!-- {{ cartStore.allCount }} -->
          <!-- {{ cartStore.allPrice.toFixed(2) }} -->
          <p>{{ $t("共") }} {{carList.length}} {{ $t("件商品") }}</p>
          <!-- <p>&yen;xx </p> -->
        </div>
        <router-link to="/cart">
          <el-button size="large" type="primary">{{
            $t("去购物车结算")
          }}</el-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cart {
  width: 100% !important;
  position: relative;
  z-index: 600;
  position: relative;
  .curr {
    line-height: 16px;
    text-align: center;
    display: block;

    .icon-cart {
      font-size: 15px;
      color: white;
    }

    .icontext {
      color: #8c8c8c !important;
    }

    em {
      font-style: normal;
      position: absolute;
      left: 10px;
      top: -8px;
      padding: 1px 6px;
      line-height: 1;
      background: #e26237;
      color: #fff;
      font-size: 7px;
      border-radius: 10px;
      font-family: Arial;
    }
  }

  &:hover {
    .layer {
      opacity: 1;
      transform: none;
    }
  }

  .layer {
    opacity: 0;
    transition: all 0.4s 0.2s;
    transform: translateY(-200px) scale(1, 0);
    width: 400px;
    height: 400px;
    position: absolute;
    top: 50px;
    right: 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    background: #fff;
    border-radius: 4px;
    padding-top: 10px;

    &::before {
      content: "";
      position: absolute;
      right: 14px;
      top: -10px;
      width: 20px;
      height: 20px;
      background: #fff;
      transform: scale(0.6, 1) rotate(45deg);
      box-shadow: -3px -3px 5px rgba(0, 0, 0, 0.1);
    }

    .foot {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 70px;
      width: 100%;
      padding: 10px;
      display: flex;
      justify-content: space-between;
      background: #f8f8f8;
      align-items: center;

      .total {
        padding-left: 10px;
        color: #999;

        p {
          &:last-child {
            font-size: 18px;
            color: #cf4444;
          }
        }
      }
    }
  }

  .list {
    height: 310px;
    overflow: auto;
    padding: 0 10px;

    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    &::-webkit-scrollbar-track {
      background: #f8f8f8;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: #eee;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #ccc;
    }

    .item {
      border-bottom: 1px solid #f5f5f5;
      padding: 10px 0;
      position: relative;

      i {
        position: absolute;
        bottom: 38px;
        right: 0;
        opacity: 0;
        color: #666;
        transition: all 0.5s;
      }

      &:hover {
        i {
          opacity: 1;
          cursor: pointer;
        }
      }

      a {
        display: flex;
        align-items: center;

        img {
          height: 80px;
          width: 80px;
        }

        .center {
          padding: 0 10px;
          width: 200px;

          .name {
            font-size: 16px;
            word-wrap: break-word;
            white-space: normal;   
          }

          .attr {
            color: #999;
            padding-top: 5px;
          }
        }

        .right {
          width: 100px;
          padding-right: 20px;
          text-align: center;

          .price {
            font-size: 16px;
            color: #cf4444;
          }

          .count {
            color: #999;
            margin-top: 5px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
